import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from "@/api/PMS/baseInformation/buildingUnit";
import { fetchListByType } from "@/api/PMS/dic/dic";
import waves from "@/directive/waves"; // 水波纹指令

import buildingAdd from "./add";
import advAdd from "../advertising/add";
import houseAdd from "../house/add";
import buildingDetail from "./detail"; // 导入弹出框

import importExcel from "./import"; // 导出

import { formatJson } from "@/utils/index";
export default {
  components: {
    buildingAdd: buildingAdd,
    buildingDetail: buildingDetail,
    advAdd: advAdd,
    houseAdd: houseAdd,
    importExcel: importExcel
  },
  directives: {
    waves: waves
  },
  props: ["routerIdArr", "id", "flagId", "activeName", "isInitSearch"],
  data: function data() {
    return {
      isDetail: false,
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        buildingName: "",
        unintName: "",
        unintOrder: "",
        unintType: "",
        unintUse: "",
        unintToward: ""
      },
      title: "",
      unintId: "",
      multipleSelection: [],
      typeOption: [],
      useOption: [],
      towardOption: [],
      cascaderItem: [],
      dialogFormVisible: false,
      dialogDetailVisible: false,
      dialogHouseVisible: false,
      dialogAdvVisible: false,
      dialogExcelVisible: false,
      // 导入
      exList: []
    };
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  created: function created() {
    this.getList();
    this.loadTypeOptions();
    this.loadUseOptions();
    this.loadTowardOptions();
  },
  methods: {
    handleDeletes: function handleDeletes() {
      var unintIds = [];
      this.multipleSelection.forEach(function (row) {
        unintIds.push(row.unintId);
      });
      this.delete(unintIds);
    },
    handCancle: function handCancle(reload) {
      this.$emit("refreshTree");
      this.$emit("loadMenuTab");

      switch (reload) {
        case true:
          this.getList();
          this.dialogFormVisible = false;
          this.dialogHouseVisible = false;
          this.dialogAdvVisible = false;
          break;

        case "offHouseEdit":
          this.dialogHouseVisible = false;
          break;

        case "offAdvertisingEdit":
          this.dialogAdvVisible = false;
          break;

        case "unitAdd":
          this.dialogFormVisible = false;
          break;
      }
    },
    handDetailCancle: function handDetailCancle(data) {
      this.getList();
      this.dialogDetailVisible = false;

      switch (data) {
        case "edit":
          this.title = "编辑";
          this.dialogFormVisible = true;
          break;

        case "house":
          this.unintId = "";
          this.title = "添加房间";
          this.dialogHouseVisible = true;
          break;

        case "adv":
          this.unintId = "";
          this.title = "添加广告位";
          this.dialogAdvVisible = true;
          break;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.buildingName = "";
        this.listQuery.unintName = "";
        this.listQuery.unintOrder = "";
        this.listQuery.unintType = "";
        this.listQuery.unintUse = "";
        this.listQuery.unintToward = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    loadTypeOptions: function loadTypeOptions() {
      var _this2 = this;

      fetchListByType("building_type").then(function (r) {
        _this2.typeOption = r.data.data;
      });
    },
    loadUseOptions: function loadUseOptions() {
      var _this3 = this;

      fetchListByType("building_use").then(function (r) {
        _this3.useOption = r.data.data;
      });
    },
    loadTowardOptions: function loadTowardOptions() {
      var _this4 = this;

      fetchListByType("building_toward").then(function (r) {
        _this4.towardOption = r.data.data;
      });
    },
    getItemDetail: function getItemDetail(unintId) {
      this.unintId = unintId;
      this.title = "详情";
      this.dialogDetailVisible = true;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.unintId = "";
      this.title = "添加";
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(unintId) {
      this.unintId = unintId;
      this.title = "编辑";
      this.dialogFormVisible = true;
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    delete: function _delete(unintIds) {
      var _this5 = this;

      if (unintIds.length > 0) {
        this.$confirm("你确定是要删除这些单元数据, 是否继续?", "提示").then(function () {
          fetchDelete(unintIds).then(function (response) {
            if (response.data.code == 200) {
              _this5.getList();

              _this5.$emit("refreshTree");

              _this5.$emit("loadMenuTab");

              _this5.Alert({
                alertType: "delete"
              });
            } else {
              _this5.Alert({
                alertType: "error",
                message: response.data.message
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(unintId) {
      var unintIds = [];
      unintIds.push(unintId);
      this.delete(unintIds);
    },
    // 导出
    handleExport: function handleExport() {
      var _this6 = this;

      this.exList = [];
      var exportList = {
        dataType: this.listQuery.dataType,
        id: this.listQuery.id,
        buildingName: this.listQuery.buildingName,
        unintName: this.listQuery.unintName,
        unintOrder: this.listQuery.unintOrder,
        unintType: this.listQuery.unintType,
        unintUse: this.listQuery.unintUse,
        unintToward: this.listQuery.unintToward
      };
      fetchList(exportList).then(function (response) {
        response.data.data.forEach(function (v, index) {
          _this6.exList.push({
            indexs: index + 1,
            areaGroupName: v.areaGroupName,
            buildingName: v.buildingName,
            unintName: v.unintName,
            // unintFloors:v.unintFloors,
            unintTypeName: v.unintTypeName,
            unintUseName: v.unintUseName,
            unintTowardName: v.unintTowardName,
            unintRemark: v.unintRemark
          });
        }); // this.exList = response.data.data;

        console.log(_this6.exList, 'this.exList');
      });
      this.$confirm("你确定要导出单元数据吗, 是否继续?", "提示").then(function () {
        if (_this6.exList !== null && _this6.exList.length > 0) {
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require("@/vendor/Export2Excel"));
          }).then(function (excel) {
            var tHeader = ["序号", "管理区域", "楼栋", "单元名称", // "层数",
            "类型", "用途", "朝向", "备注"];
            var fileterVal = ["indexs", "areaGroupName", "buildingName", "unintName", // "unintFloors",
            "unintTypeName", "unintUseName", "unintTowardName", "unintRemark"];
            var data = formatJson(fileterVal, _this6.exList);
            excel.export_json_to_excel({
              header: tHeader,
              data: data,
              filename: "单元数据",
              autoWidth: true,
              bookType: "xlsx"
            });
          });
        } else {
          _this6.Alert({
            alertType: "error",
            message: "暂无数据，无法导出！"
          });
        }
      });
    },
    // 导入
    handleUpload: function handleUpload() {
      this.title = "导入Excel";
      this.dialogExcelVisible = true;
    },
    exhandCancle: function exhandCancle() {
      this.dialogExcelVisible = false;
      this.dialogFormVisible = false;
      this.getList();
      this.$emit("refreshTree");
      this.$emit("loadMenuTab");
    }
  }
};